// Research & Development Skills organized by subcategories
export const RESEARCH_DEVELOPMENT_SKILLS_CATEGORIES = [
  {
    name: 'Research Methodology',
    skills: [
      'Research Design', 'Experimental Methods', 'Data Collection',
      'Research Planning', 'Hypothesis Testing', 'Research Protocols',
      'Study Design', 'Research Ethics', 'Research Standards',
      'Methodology Selection', 'Research Strategy', 'Research Tools',
      'Research Documentation', 'Research Validation', 'Quality Control'
    ]
  },
  {
    name: 'Data Analysis',
    skills: [
      'Statistical Analysis', 'Data Interpretation', 'Quantitative Analysis',
      'Qualitative Analysis', 'Data Modeling', 'Data Visualization',
      'Research Software', 'Data Mining', 'Pattern Recognition',
      'Trend Analysis', 'Predictive Analysis', 'Research Analytics',
      'Data Validation', 'Results Analysis', 'Analytical Tools'
    ]
  },
  {
    name: 'Product Development',
    skills: [
      'Product Design', 'Prototype Development', 'Product Testing',
      'Product Validation', 'Design Optimization', 'Product Innovation',
      'Development Process', 'Quality Standards', 'Product Documentation',
      'Product Strategy', 'Market Analysis', 'User Research',
      'Product Planning', 'Product Launch', 'Product Lifecycle'
    ]
  },
  {
    name: 'Laboratory Skills',
    skills: [
      'Lab Techniques', 'Equipment Operation', 'Sample Preparation',
      'Lab Safety', 'Quality Control', 'Lab Documentation',
      'Protocol Development', 'Lab Management', 'Equipment Maintenance',
      'Lab Analysis', 'Testing Methods', 'Lab Standards',
      'Lab Procedures', 'Lab Software', 'Lab Reporting'
    ]
  },
  {
    name: 'Innovation Management',
    skills: [
      'Innovation Strategy', 'Creative Problem Solving', 'Idea Generation',
      'Innovation Process', 'Technology Innovation', 'Product Innovation',
      'Process Innovation', 'Innovation Tools', 'Innovation Assessment',
      'Innovation Planning', 'Innovation Implementation', 'Innovation Metrics',
      'Innovation Culture', 'Innovation Leadership', 'Change Management'
    ]
  },
  {
    name: 'Project Management',
    skills: [
      'Research Planning', 'Project Coordination', 'Resource Management',
      'Timeline Management', 'Budget Control', 'Team Leadership',
      'Risk Management', 'Quality Assurance', 'Project Documentation',
      'Stakeholder Management', 'Progress Monitoring', 'Project Strategy',
      'Performance Metrics', 'Project Reporting', 'Project Tools'
    ]
  },
  {
    name: 'Technical Writing',
    skills: [
      'Research Documentation', 'Technical Reports', 'Protocol Writing',
      'Publication Writing', 'Grant Writing', 'Documentation Standards',
      'Technical Communication', 'Research Papers', 'Patent Writing',
      'Procedure Documentation', 'Quality Documentation', 'Writing Tools',
      'Document Management', 'Writing Standards', 'Editorial Skills'
    ]
  },
  {
    name: 'Intellectual Property',
    skills: [
      'Patent Research', 'IP Strategy', 'Patent Writing',
      'IP Protection', 'IP Management', 'Patent Analysis',
      'IP Documentation', 'IP Rights', 'IP Portfolio',
      'Patent Process', 'IP Assessment', 'IP Tools',
      'IP Reporting', 'IP Standards', 'Legal Compliance'
    ]
  },
  {
    name: 'Quality Management',
    skills: [
      'Quality Standards', 'Quality Control', 'Quality Assurance',
      'Quality Systems', 'Quality Tools', 'Quality Documentation',
      'Quality Metrics', 'Quality Planning', 'Quality Analysis',
      'Quality Improvement', 'Quality Reporting', 'Quality Strategy',
      'Quality Training', 'Quality Audits', 'Compliance Management'
    ]
  },
  {
    name: 'Team Leadership',
    skills: [
      'Team Management', 'Research Leadership', 'Performance Management',
      'Team Development', 'Collaboration Skills', 'Communication Skills',
      'Mentoring', 'Team Building', 'Conflict Resolution',
      'Leadership Strategy', 'Team Planning', 'Staff Development',
      'Team Coordination', 'Leadership Skills', 'Team Culture'
    ]
  },
  {
    name: 'Market Research',
    skills: [
      'Market Analysis', 'Consumer Research', 'Competitive Analysis',
      'Market Trends', 'Industry Research', 'Market Strategy',
      'Research Methods', 'Data Collection', 'Market Intelligence',
      'Market Assessment', 'Research Tools', 'Market Planning',
      'Market Reports', 'Research Analysis', 'Market Insights'
    ]
  },
  {
    name: 'Technology Assessment',
    skills: [
      'Technology Evaluation', 'Technical Analysis', 'Technology Strategy',
      'Technology Planning', 'Technology Implementation', 'Technology Tools',
      'Technology Standards', 'Technology Assessment', 'Technology Metrics',
      'Technology Research', 'Technology Reports', 'Technology Management',
      'Technology Innovation', 'Technology Trends', 'Technology Impact'
    ]
  }
];

// Export flattened list for backward compatibility
export const RESEARCH_DEVELOPMENT_SKILLS = RESEARCH_DEVELOPMENT_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
